import getMessage from 'src/background/utils/i18n.utils';
import React from 'react';
export const WitnessInfoDataComponent = ({ label, skipLabelTranslation, value, valueOnClickAction, extraInfo, extraInfoAdditionalClass, }) => {
    const handleOnValueClick = () => {
        if (valueOnClickAction) {
            valueOnClickAction();
        }
    };
    return (React.createElement("div", { className: "witness-info-data" },
        React.createElement("div", { className: "label" }, skipLabelTranslation ? label : getMessage(label)),
        React.createElement("div", { className: `value ${valueOnClickAction ? 'clickable' : ''}`, onClick: handleOnValueClick },
            React.createElement(React.Fragment, null,
                React.createElement("span", null, value))),
        extraInfo && (React.createElement("div", { className: `extra-info ${extraInfoAdditionalClass !== null && extraInfoAdditionalClass !== void 0 ? extraInfoAdditionalClass : ''}` }, extraInfo))));
};
